import AlertModal from '@/components/ux/AlertModal/AlertModal';
import Layout from '@/components/ux/Layout';
import { log } from '@/helpers';
import { CampaignTag } from '@/legacy-types';
import { useCampaignTagsStore } from '@/stores/campaigns/useCampaignTagsStore';
import { ColorPickerInput, Flex, FormInput } from '@alpine-iq/ui-library';
import React from 'react';
import { create } from 'zustand';

// Small zustand store for the drawer
type CampaignTagDrawerStore = {
	openTagID: string | undefined;
	setOpenTagID: (openTagID: string | undefined) => void;
};

export const useCampaignTagDrawerStore = create<CampaignTagDrawerStore>((set) => ({
	openTagID: undefined,
	setOpenTagID: (openTagID) => set({ openTagID }),
}));

export default function CampaignTagDrawer() {
	const { loaded: loadedTags, tags, upsertCampaignTag } = useCampaignTagsStore();
	const { openTagID, setOpenTagID } = useCampaignTagDrawerStore();

	const [editingTag, setEditingTag] = React.useState<Partial<CampaignTag> | undefined>(undefined);

	React.useEffect(() => {
		if (openTagID && loadedTags) {
			setEditingTag(tags[openTagID]);
		}
	}, [openTagID, loadedTags]);

	return (
		<>
			<AlertModal
				open={!!openTagID}
				onClose={() => setOpenTagID(undefined)}
				onConfirm={() => {
					setOpenTagID(undefined);
					if (editingTag) {
						upsertCampaignTag(editingTag);
					}
				}}
				title={editingTag ? 'Edit Tag' : 'Create Tag'}
			>
				<Layout>
					<Flex
						column
						gap="24"
					>
						<FormInput
							label="Name"
							value={editingTag?.name}
							onChange={(e) => setEditingTag({ ...editingTag, name: e.target.value })}
						/>
						<ColorPickerInput
							label="Color"
							value={editingTag?.color ?? '#e2e6ed'}
							onChange={(e) => setEditingTag({ ...editingTag, color: e })}
						/>
					</Flex>
				</Layout>
			</AlertModal>
		</>
	);
}
